import React, { Component } from 'react';
import AuthFunctions from '../services/AuthService';
import Session from '../auth/Session';
import AdminFunctions from '../admin/AdminFunctions';
import AccountFunctions from '../services/AccountService';
import { Container, Row, Col, Input, Button, Table, Spinner, UncontrolledTooltip } from 'reactstrap';
import { FaSort } from 'react-icons/fa'
import '../layout/site.css';
import '../layout/print.css';
import Moment from 'react-moment';
import Modal from 'react-bootstrap/Modal';

export class AccountInvoices extends Component {
    static displayName = AccountInvoices.name;

    constructor(props) {
        super(props);

        this.state = {
            siteList: [],
            client: null,
            search: null,
            searchType: 2,
            fromDate: null,
            toDate: null,
            invoices: [],
            invoice: { details: [] },
            invoiceOrig: [],
            height: 0,
            width: 0,
            sort: {
                column: null,
                direction: 'desc'
            },
            loading: false,
            noResults: false,
            currentPage: 1,
            itemsPerPage: 100,
            numberOfPages: 0,
            today: new Date(),
            toastTitle: '',
            toastBody: '',
            toastButton: true,
            showToast: false,
            toastSpinner: false,
        };
        this.handleClick = this.handleClick.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handlePageSizeChange = this.handlePageSizeChange.bind(this);
        this.searchInvoiceNo = this.searchInvoiceNo.bind(this);
        this.formatCurrency = this.formatCurrency.bind(this);
        this.handleClose = this.handleClose.bind(this);
        //window.addEventListener('resize', this.setWindowDimensions);
        this.checkAuthenticated();
    }

    async checkAuthenticated() {
        var isAuthenticated = await AuthFunctions.getAuthenticatedAsync();
        if (!isAuthenticated) {
            this.props.history.push('/login');
        }
    }

    formatCurrency(value) {
        if (value == null || value == undefined) {
            return '0.00';
        } else {
            return value.toFixed(2);
        }
    }

    handleClick(event) {
        let id = Number(event.target.id);

        if (id === 0) {
            this.setState({
                currentPage: 1
            });
        } else if (id === -1) {
            this.setState({
                currentPage: Math.ceil(this.state.invoices.length / this.state.itemsPerPage)
            });
        } else {
            this.setState({
                currentPage: Number(event.target.id)
            });
        }
    }

    handleChange(event) {
        this.setState({ currentPage: Number(event.target.value) });
    }

    handleClose() {
        this.setState({ showToast: false });
    }
    handlePageSizeChange(event) {
        let pageSize = Number(event.target.value);
        this.setState({ itemsPerPage: pageSize });
        if (this.state.currentPage > Math.ceil(this.state.invoices.length / pageSize)) {
            this.setState({ currentPage: Math.ceil(this.state.invoices.length / pageSize) })
        }
    }

    async handlePrintInvoice(invoiceNo) {
        this.setState({ toastTitle: 'Loading Invoice', toastBody: 'The invoice data is loading, please wait...', toastButton: false, toastSpinner: true, showToast: true });

        var invoice = await AccountFunctions.getInvoiceAsync(invoiceNo);

        if (invoice.success == true) {
            this.setState({ toastTitle: '', toastBody: '', toastButton: true, toastSpinner: false, showToast: false });

            if (invoice.data != null && invoice.data.length != 0) {
                var data = invoice.data[0];
                console.log(data);
                this.setState({ invoice: data });

                setTimeout(() => {
                    window.print();
                }, 500);
            }
        }
        else {
            this.setState({ toastTitle: 'Error!', toastBody: 'There was an unexpected problem loading the invoice information.', toastButton: true, toastSpinner: false, showToast: true });
        }
    }

    async componentDidMount() {
        document.getElementsByTagName('html')[0].className = "";
        //this.setWindowDimensions();
        const isAdmin = await AdminFunctions.isAdminAsync();
        this.setState({ isAdmin: isAdmin });
        if (isAdmin) {

        }
        else {
        }
        this.getInvoiceData();
    }

    //setWindowDimensions = () => {
    //    this.setState({
    //        height: window.innerHeight,
    //        width: window.innerWidth
    //    });
    //};

    handleKeyPress(event) {
        if (event.key === 'Enter') {
            this.searchInvoiceNo();
        }
    }

    async getInvoiceData() {
        var invoices = await AccountFunctions.getInvoicesAsync();

        if (invoices.success == true) {
            if (invoices.data != null) {
                this.setState({ invoiceOrig: invoices.data, invoices: invoices.data.slice() });
            }
        }
    }

    render() {
        // Logic for displaying invoices!
        const indexOfLastItem = this.state.currentPage * this.state.itemsPerPage;
        const indexOfFirstItem = indexOfLastItem - this.state.itemsPerPage;
        const currentItems = this.state.invoices.slice(indexOfFirstItem, indexOfLastItem);

        const renderItems = currentItems.map((invoice, i) => {
            return (
                <tr key={i} style={{ backgroundColor: (invoice.dueDate < this.state.today && invoice.paymentStatus == 'Not Paid') ? 'red' : 'white' }}>
                    <td><a href="javascript:void(0)" onClick={(e) => this.handlePrintInvoice(invoice.invoiceNo)}>Print</a></td>
                    <td>{invoice.invoiceNo}</td>
                    <td>{invoice.customerPO}</td>
                    <td>{invoice.invoiceDate != null && <Moment format="M/D/YY">{invoice.invoiceDate}</Moment>}</td>
                    <td>{invoice.dueDate != null && <Moment format="M/D/YY">{invoice.dueDate}</Moment>}</td>
                    <td>{invoice.netTerms}</td>
                    <td>{invoice.paymentMethod}</td>
                    <td>{invoice.paymentStatus}</td>
                </tr>
            )
        });

        const renderPrintItems = this.state.invoice.details.map((detail, i) => {
            return (
                <tr key={i}>
                    <td>{detail.qty == 0 ? '' : detail.qty}</td>
                    <td>{detail.partNo}</td>
                    <td>{detail.mte}</td>
                    <td>{detail.description}</td>
                    <td style={{ textAlign: 'right' }}>{detail.qty == 0 ? '' : this.formatCurrency(detail.cost)}</td>
                    <td style={{ textAlign: 'right' }}>{detail.qty == 0 ? '' : this.formatCurrency(detail.extended)}</td>
                </tr>
            )
        });

        // Logic for displaying page numbers
        const pageNumbers = [];
        for (let i = 1; i <= Math.ceil(this.state.invoices.length / this.state.itemsPerPage); i++) {
            pageNumbers.push(i);
        }

        const renderPageNumbers = pageNumbers.map(number => {
            return (
                <option value={number}>{number}</option>
            );
        });

        return (
            <>
                <div className='content-area'>
                    <Container>
                        <Row>
                            <Col>
                                <h2 style={{ color: '#233c7c' }}>Invoices</h2>
                            </Col>
                        </Row>
                        <Row style={{ marginTop: '20px' }}>
                            <div className='col' style={{ maxWidth: '200px' }}></div>
                            <div className='col' style={{ maxWidth: '200px' }}>From Date</div>
                            <div className='col' style={{ maxWidth: '200px' }}>To Date</div>
                        </Row>
                        <Row>
                            <div className='col' style={{ maxWidth: '200px' }}>
                                <Input
                                    type='text'
                                    onChange={(e) => this.setState({ search: e.target.value })}
                                    name='search'
                                    id='search'
                                    style={{ width: '200px'}}
                                    onKeyPress={(e) => this.handleKeyPress(e)}
                                    placeholder='Enter Invoice #, PO #'
                                />
                            </div>
                            <div className='col' style={{ maxWidth: '200px' }}>
                                <Input
                                    type='date'
                                    onChange={(e) => this.setState({ fromDate: e.target.value })}
                                    name='DateFrom'
                                    id='DateFrom'
                                    onKeyPress={(e) => this.handleKeyPress(e)}
                                    placeholder='From Date'
                                />
                            </div>
                            <div className='col' style={{ maxWidth: '200px' }}>
                                <Input
                                    type='date'
                                    onChange={(e) => this.setState({ toDate: e.target.value })}
                                    name='DateTo'
                                    id='DateTo'
                                    onKeyPress={(e) => this.handleKeyPress(e)}
                                    placeholder='To Date'
                                />
                            </div>

                            <Col style={{ minWidth: '250px' }}>
                                <div>
                                    <Input
                                        type='radio'
                                        onChange={(e) => this.setState({ searchType: 1 })}
                                        name='paidStatus'
                                        id='paidStatus'
                                        placeholder='UnpaidInvoice'
                                        checked={this.state.searchType == 1}
                                    /> <span> Show Unpaid Invoices</span>
                                </div>
                                <div>
                                    <Input
                                        type='radio'
                                        onChange={(e) => this.setState({ searchType: 2 })}
                                        name='paidStatus'
                                        id='paidStatus'
                                        placeholder='AllInvoice'
                                        checked={this.state.searchType == 2}
                                    /> <span> Show All Invoices</span>
                                </div>
                            </Col>
                            <div className='col' style={{textAlign: 'right'}}>
                                <Button
                                    color='primary'
                                    onClick={() => this.searchInvoiceNo()}
                                    style={{ width: '125px' }}
                                    disabled={this.state.loading ? true : false}
                                >
                                    Search
                                </Button>
                            </div>
                        </Row>
                        {this.state.invoices.length !== 0 && (
                            <div style={{ display: 'flex', justifyContent: 'right', alignItems: 'right', textAlign: 'center', marginTop: '20px' }}>
                                <label style={{ marginRight: '10px', marginTop: '5px' }}>Page</label>
                                <select className='form-control' style={{ width: '75px' }} value={this.state.currentPage} onChange={this.handleChange}>
                                    {renderPageNumbers}
                                </select>
                                <label style={{ marginRight: '10px', marginLeft: '10px', marginTop: '5px' }}>Page Size</label>
                                <select className='form-control' style={{ width: '75px' }} value={this.state.itemsPerPage} onChange={this.handlePageSizeChange}>
                                    <option value="10">10</option>
                                    <option value="25">25</option>
                                    <option value="50">50</option>
                                    <option value="100">100</option>
                                </select>
                            </div>
                        )}
                        <Row style={{ marginTop: '20px' }}>
                            <Col xl='12' lg='12' md='12' sm='12' xs='12'>
                                <Table responsive>
                                    <thead>
                                        <tr>
                                            <th>
                                                Print
                                            </th>
                                            <th>
                                                Invoice #
                                                <FaSort
                                                    color={this.state.sort.column === 'invoiceNo' ? '#0a58ca' : 'black'}
                                                    onClick={() => this.handleSort('invoiceNo')}
                                                    className='sort-button'
                                                />
                                            </th>
                                            <th>
                                                PO #
                                                <FaSort
                                                    color={this.state.sort.column === 'customerPO' ? '#0a58ca' : 'black'}
                                                    onClick={() => this.handleSort('customerPO')}
                                                    className='sort-button'
                                                />
                                            </th>
                                            <th>
                                                Inv. Date
                                                <FaSort
                                                    color={this.state.sort.column === 'invoiceDate' ? '#0a58ca' : 'black'}
                                                    onClick={() => this.handleSort('invoiceDate')}
                                                    className='sort-button'
                                                />
                                            </th>
                                            <th>
                                                Due Date
                                                <FaSort
                                                    color={this.state.sort.column === 'dueDate' ? '#0a58ca' : 'black'}
                                                    onClick={() => this.handleSort('dueDate')}
                                                    className='sort-button'
                                                />
                                            </th>
                                            <th>
                                                Terms
                                                <FaSort
                                                    color={this.state.sort.column === 'netTerms' ? '#0a58ca' : 'black'}
                                                    onClick={() => this.handleSort('netTerms')}
                                                    className='sort-button'
                                                />
                                            </th>
                                            <th>
                                                Pay. Method
                                                <FaSort
                                                    color={this.state.sort.column === 'paymentMethod' ? '#0a58ca' : 'black'}
                                                    onClick={() => this.handleSort('paymentMethod')}
                                                    className='sort-button'
                                                />
                                            </th>
                                            <th>
                                                Pay. Status
                                                <FaSort
                                                    color={this.state.sort.column === 'paymentStatus' ? '#0a58ca' : 'black'}
                                                    onClick={() => this.handleSort('paymentStatus')}
                                                    className='sort-button'
                                                />
                                            </th>

                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.loading === true && this.state.loadingDocument === false ? (
                                            <tr>
                                                <td style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', textAlign: 'center', minHeight: '50vh', position: 'absolute', top: '50%', left: '50%', marginTop: '-50px', marginLeft: '-50px' }}>
                                                    <Spinner color="primary" children='' />
                                                </td>
                                            </tr>

                                        ) : (
                                            <>
                                                {!this.state.noResults ? (
                                                    <>
                                                        {renderItems}
                                                    </>
                                                ) : (
                                                    <tr>
                                                        <td style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', textAlign: 'center', position: 'absolute', top: '50%', left: '50%', marginTop: '-50px', marginLeft: '-50px' }}>
                                                            <h5>No Results Found</h5>
                                                        </td>
                                                    </tr>
                                                )}
                                            </>
                                        )}
                                    </tbody>
                                </Table>
                            </Col>
                        </Row>
                        {this.state.invoices.length !== 0 && (
                            <div style={{ display: 'flex', justifyContent: 'right', alignItems: 'right', textAlign: 'center', marginTop: '20px' }}>
                                <label style={{ marginRight: '10px', marginTop: '5px' }}>Page</label>
                                <select className='form-control' style={{ width: '75px' }} value={this.state.currentPage} onChange={this.handleChange}>
                                    {renderPageNumbers}
                                </select>
                                <label style={{ marginRight: '10px', marginLeft: '10px', marginTop: '5px' }}>Page Size</label>
                                <select className='form-control' style={{ width: '75px' }} value={this.state.itemsPerPage} onChange={this.handlePageSizeChange}>
                                    <option value="10">10</option>
                                    <option value="25">25</option>
                                    <option value="50">50</option>
                                    <option value="100">100</option>
                                </select>
                            </div>
                        )}
                    </Container>
                    <Modal show={this.state.showToast} onHide={this.handleClose}>
                        <Modal.Header >
                            <Modal.Title>{this.state.toastTitle}</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            {this.state.toastSpinner &&
                                <Spinner color="primary" children='' style={{ marginRight: '20px' }} />
                            }
                            {this.state.toastBody}
                        </Modal.Body>
                        <Modal.Footer>
                            {this.state.toastButton &&
                                <Button className='standardButton btn btn-primary' onClick={this.handleClose}>
                                    Close
                                </Button>
                            }
                        </Modal.Footer>
                    </Modal>
                </div>
                <div className="print-area">
                    <Container>
                        <Row>
                            <Col>
                                <Table responsive className='borderless-table'>
                                    <tbody>
                                        <tr>
                                            <td colSpan={'2'} style={{ textAlign: 'center' }}>
                                                <img src="/images/ticlogo.jpg" style={{ height: '80px', margin: '12px' }} />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td colSpan={'2'} style={{ textAlign: 'center' }}>
                                                647 TRADE CENTER BLVD CHESTERFIELD, MO 63005<br />
                                                314-432-3633 - FAX 314-432-3773 - WWW.TICMS.COM
                                            </td>
                                        </tr>
                                    </tbody>
                                </Table>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Table responsive className='borderless-table'>
                                    <tbody>
                                        <tr>
                                            <td>
                                                <Table responsive className='print-table borderless-table'>
                                                    <tbody>
                                                        <tr>
                                                            <td rowSpan={'4'} style={{width: '100px'}}><b>SHIP TO:</b></td>
                                                            <td>Attn: {this.state.invoice.ccpMan}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>{this.state.invoice.custName}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>{this.state.invoice.shipTo}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>{this.state.invoice.shipCity} {this.state.invoice.shipState} {this.state.invoice.shipZip}</td>
                                                        </tr>
                                                        <tr>
                                                            <td rowSpan={'4'} style={{ width: '100px' }}><b>BILL TO:</b></td>
                                                            <td>Attn: {this.state.invoice.acctMan}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>{this.state.invoice.billName}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>{this.state.invoice.billTo}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>{this.state.invoice.billCity} {this.state.invoice.billState} {this.state.invoice.billZip}</td>
                                                        </tr>
                                                    </tbody>
                                                </Table>
                                            </td>
                                        </tr>
                                    </tbody>
                                </Table>
                            </Col>
                            <Col>
                                <Table responsive className='borderless-table'>
                                    <tbody>
                                        <tr>
                                            <td>
                                                <Table responsive className='print-table borderless-table'>
                                                    <tbody>
                                                        <tr>
                                                            <td style={{ width: '100px' }}><b>Invoice No:</b></td>
                                                            <td>{this.state.invoice.invoiceNo}</td>
                                                        </tr>
                                                        <tr>
                                                            <td style={{ width: '100px' }}><b>Inv Date:</b></td>
                                                            <td>{this.state.invoice.invoiceDate != null && <Moment format="M/D/YY">{this.state.invoice.invoiceDate}</Moment>}</td>
                                                        </tr>
                                                        <tr>
                                                            <td style={{ width: '100px' }}><b>Customer #:</b></td>
                                                            <td>{this.state.invoice.ticNo}</td>
                                                        </tr>
                                                        <tr>
                                                            <td style={{ width: '100px' }}><b>P.O. #:</b></td>
                                                            <td>{this.state.invoice.customerPO}</td>
                                                        </tr>
                                                        <tr>
                                                            <td style={{ width: '100px' }}><b>Terms:</b></td>
                                                            <td>{this.state.invoice.netTerms}</td>
                                                        </tr>
                                                        <tr>
                                                            <td style={{ width: '100px' }}><b>Ship Via:</b></td>
                                                            <td>{this.state.invoice.shipVia}</td>
                                                        </tr>
                                                    </tbody>
                                                </Table>
                                            </td>
                                        </tr>
                                    </tbody>
                                </Table>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Table responsive className='print-table borderless-table'>
                                    <thead>
                                        <tr>
                                            <th>
                                                QTY
                                            </th>
                                            <th>
                                                TIC REF#
                                            </th>
                                            <th>
                                                CUST ID
                                            </th>
                                            <th>
                                                DESCRIPTION
                                            </th>
                                            <th style={{textAlign: 'right'}}>
                                                COST
                                            </th>
                                            <th style={{ textAlign: 'right' }}>
                                                EXTENDED
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <>
                                            {renderPrintItems}
                                        </>
                                        <tr>
                                            <td colSpan={'5'} style={{ textAlign: 'right' }}></td>
                                            <td style={{ textAlign: 'right' }}></td>
                                        </tr>
                                        <tr>
                                            <td colSpan={'5'} style={{ textAlign: 'right' }}><b>Parts:</b></td>
                                            <td style={{ textAlign: 'right' }}>{this.formatCurrency(this.state.invoice.parts)}</td>
                                        </tr>
                                        <tr>
                                            <td colSpan={'5'} style={{ textAlign: 'right' }}><b>Tax:</b></td>
                                            <td style={{ textAlign: 'right' }}>{this.formatCurrency(this.state.invoice.taxes)}</td>
                                        </tr>
                                        <tr>
                                            <td colSpan={'5'} style={{ textAlign: 'right' }}><b>Shipping - Handling & Ins.:</b></td>
                                            <td style={{ textAlign: 'right' }}>{this.formatCurrency(this.state.invoice.freight)}</td>
                                        </tr>
                                        <tr>
                                            <td colSpan={'5'} style={{ textAlign: 'right' }}><b>Grand Total:</b></td>
                                            <td style={{ textAlign: 'right' }}>{this.formatCurrency(this.state.invoice.total)}</td>
                                        </tr>
                                    </tbody>
                                </Table>
                            </Col>
                        </Row>
                    </Container>
                </div>
                <div className='print-watermark'></div>
            </>
        )
    }

    // invoices

    async searchInvoices() {
        this.setState({ loading: true, loadingDocument: false });
        const token = Session.getToken();
        const query = this.state.search ? this.state.search : '';
        //const clientId = (this.state.client && this.state.client.length !== 0) ? this.state.client[0].id : 0;
        var client = (this.state.client && this.state.client.length !== 0) ? this.state.client[0] : '';

        if (typeof client !== 'string' && !(client instanceof String)) {
            client = client.label;
        }

        const response = await fetch(`api/Account/SearchInvoices?query=${query}&client=${client}`, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });
        const data = await response.json();
        this.setState({ invoices: data, loading: false, noResults: data.length === 0 ? true : false });
    }

    // table sort

    searchInvoiceNo() {
        var invoices = this.state.invoiceOrig;
        var search = this.state.search;
        var searchType = this.state.searchType;
        var fromDate = this.state.fromDate;
        var toDate = this.state.toDate;

        if (search != null && search != "") {
            invoices = invoices.filter(function (invoice) {
                return (invoice.invoiceNo.includes(search) || invoice.customerPO.includes(search));
            });
        }

        invoices = invoices.filter(function (invoice) {
            return (searchType == 2 || (searchType == 1 && invoice.paymentStatus == 'Not Paid'));
        });

        if (fromDate !== null && fromDate !== '') {
            var from = new Date(fromDate);
            invoices = invoices.filter(function (invoice) {
                var invoiceDate = new Date(invoice.invoiceDate);
                return (invoiceDate.getTime() >= from.getTime());
            });
        }

        if (toDate !== null && toDate !== '') {
            var to = new Date(toDate);
            var endOfDay = 24 * 60 * 60 * 1000;
            invoices = invoices.filter(function (invoice) {
                var invoiceDate = new Date(invoice.invoiceDate);
                return (invoiceDate.getTime() <= to.getTime() + endOfDay);
            });
        }

        this.setState({ invoices: invoices });
    }

    handleSort(column) {
        const direction = this.state.sort.column ? (this.state.sort.direction === 'asc' ? 'desc' : 'asc') : 'desc';
        const data = this.state.invoices;

        if (column == 'dueDate' || column == 'invoiceDate') {
            data.sort((a, b) => {
                var dateA = new Date(a[column]);
                var dateB = new Date(b[column]);
                return dateB - dateA;
            });
        } else {
            data.sort((a, b) => a[column] instanceof Date ? (b[column] - a[column]) : a[column].localeCompare(b[column]));
        }


        if (direction === 'desc') {
            data.reverse();
        }
        this.setState({
            invoices: data,
            sort: {
                column,
                direction
            }
        })
    }
}